import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';
import Panel from 'Components/Panel';
import { actions } from 'ducks/readings';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HEADER_HEIGHT, SPACER_MINI, TABS_HEIGHT } from 'utils/ui/constants';
import Details from './Details';
import Measurements from './Measurements';
import Toolbar from './Toolbar';

const MainContainer = styled(Grid)(({ theme }) => ({
    height: `calc(100vh - ${HEADER_HEIGHT}px)`,
    backgroundColor: theme.palette.backgrounds.color.main,
    padding: '0px 10px 0px'
}));

const HeaderContainer = styled(Grid)(() => ({
    height: `${TABS_HEIGHT + SPACER_MINI}px`
}));

const BottomContainer = styled(Grid)(() => ({
    height: `calc(100% - ${TABS_HEIGHT + SPACER_MINI + SPACER_MINI}px)`,
    paddingBottom: 5,
    overflowY: 'auto'
}));

const Component = ({ disableButtons = false, id, onClose }) => {
    const reading = useSelector(state => state.readings.models[id || state.drawerView.entityId]);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.fetchOne(reading.id));
    }, [reading.id, dispatch]);

    return (
        <MainContainer container>
            <HeaderContainer size={12}>
                <Toolbar disableButtons={disableButtons} onClose={onClose} reading={reading}/>
            </HeaderContainer>
            <BottomContainer size={12}>
                <div id="properties" style={{ margin: '8px 0' }}>
                    <Panel header="Details">
                        <Details reading={reading}/>
                    </Panel>
                </div>
                <div id="measurements" style={{ margin: '8px 0' }}>
                    <Panel header="Measurements">
                        <Measurements measurements={reading.measurements}/>
                    </Panel>
                </div>
            </BottomContainer>
        </MainContainer>
    );
};

export default Component;
